export const findIndexById = (items, id) =>
    items.findIndex(item => item.id === id);

export const mapById = items => {
    const itemsMap = new Map();
    items.forEach(item => itemsMap.set(item.id, item));
    return itemsMap;
};

const getItemsIds = items =>
    items.reduce((itemIds, media) => {
        if (media.project_media_id.media === null) {
            return itemIds;
        }
        return { ...itemIds, [media.id]: false };
    }, {});

export const getMediasIdsMap = items =>
    items.reduce(
        (mediaIds, item) => ({ ...mediaIds, ...getItemsIds(item.medias) }),
        {}
    );
